const initialState = { 
  loading: false,
  success: null,
  error: null
}

function saveProductReducer(state = initialState, action) {
  switch (action.type) {
    case 'SAVE_PRODUCT_BEGIN':
      return {
        ...state,
        loading: true,
        success: null,
        error: null
      }

    case 'SAVE_PRODUCT_SUCCESS':
      return {
        ...state,
        loading: false,
        success: action.success
      }

    case 'SAVE_PRODUCT_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.error
      }

    default: return state
  }
}

export default saveProductReducer